import axios from 'axios';

export const useFetchFilters = async (): Promise<Array<unknown>> => {
    const data = await axios.post(
        `${process.env.DRUPAL_URL}/graphql`,
        {
            query: `query filtersType {
                            product_search {
                                schema
                            }
                    }
            `,
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    const result = JSON.parse(data?.data?.data?.product_search?.schema);
    return (
        [
            [result?.type?.type, result?.type?.mode],
            [result?.compression_mode],
            [result?.pressure_range],
            [
                result?.equipment?.heat_recovery,
                result?.equipment?.sound_absorption,
                result?.equipment?.delivery_control,
                result?.equipment?.cooling,
                result?.equipment?.others,
            ],
        ] ?? []
    );
};
